<template>
  <div>
    <Toolset
      ref="toolset"
      :searcher="handleSearch"
      add-button-icon="pi pi-plus"
      add-button-label="Cargar cartas externas"
      :to-add="handleAdd"
      class="mt-5"
    >
    </Toolset>
    <DataTable
      class="tabla mb-5 mt-3"
      :value="letterConfigs.data"
      paginator
      lazy
      :rows="letterConfigs.meta.perPage || 10"
      :first="
        ((letterConfigs.meta.currentPage || 1) - 1) *
        (letterConfigs.meta.perPage || 10)
      "
      :loading="loading"
      :rowsPerPageOptions="[5, 10, 20, 50]"
      tableStyle="min-width: 50rem"
      removableSort
      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
      :totalRecords="letterConfigs.meta.total"
      :currentPageReportTemplate="currentPageReportTemplate"
      scrollable
      scrollHeight="600px"
      sortField="updatedAt"
      :sortOrder="-1"
      @page="handlePage"
    >
      <template #empty> No se encontraron cartas.</template>
      <Column field="name" header="Nombre" sortable></Column>
      <Column field="description" header="Descripción" sortable></Column>
      <Column field="generationType" header="Tipo de carta" sortable></Column>
      <Column field="payrolls" header="Nóminas" sortable>
        <template #body="{ data }">
          <span class="font-semibold text-overflow-elipsis">
            {{ payrollsToString(data.payrolls) }}
          </span>
        </template>
      </Column>
      <Column field="updatedAt" header="Última actualización" sortable>
        <template #body="{ data, field }">
          <span>{{ formatDateWithHour(data[field]) }}</span>
        </template>
      </Column>
      <Column header="Acciones">
        <template #body="{ data }">
          <ConfirmPopup></ConfirmPopup>
          <div class="actions">
            <Button
              v-tooltip.bottom="'Ver detalles'"
              class="action-btn view p-button-sm mr-2"
              icon="pi pi-eye"
              @click="handleViewDetails(data['id'], data['generationType'])"
            />
            <Button
              v-tooltip.bottom="'Eliminar'"
              class="action-btn view p-button-sm px-4 bg-red-500 border-red-500"
              :loading="deletingId === data['id']"
              :disabled="deletingId === data['id']"
              @click="(event) => handleDelete(event, data['id'])"
            >
              <i class="pi pi-trash text-white"></i>
            </Button>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import Toolset from '@/shared/components/Toolset.vue'
  import type PaginatedResult from '@/shared/dtos/PaginatedResult'
  import type LetterConfigList from '../models/LetterConfig'
  import type Payroll from '@/modules/payrolls-config/models/Payroll'

  interface ExternalLettersSectionProps {
    letterConfigs: PaginatedResult<LetterConfigList>
    loading: boolean
    deletingId?: string | null
    currentPageReportTemplate: string
    payrollsToString: (payrolls: Payroll[]) => string
    formatDateWithHour: (value: any) => string
  }

  defineProps<ExternalLettersSectionProps>()

  const emit = defineEmits<{
    (e: 'search', value: string): void
    (e: 'add'): void
    (e: 'view', value: { id: string; generationType: string }): void
    (e: 'delete', value: { event: any; id: string; isExternal: true }): void
    (e: 'page', value: { page: number; perPage: number }): void
  }>()

  const toolset = ref<{ search: any } | null>(null)

  const extractSearchValue = () => {
    const search = toolset.value?.search
    return typeof search === 'string' ? search : search?.value ?? ''
  }

  const handleSearch = () => {
    emit('search', extractSearchValue())
  }

  const handleAdd = () => {
    emit('add')
  }

  const handlePage = (event: any) => {
    emit('page', { page: event.page + 1, perPage: event.rows })
  }

  const handleViewDetails = (id: string, generationType: string) => {
    emit('view', { id, generationType })
  }

  const handleDelete = (event: any, id: string) => {
    emit('delete', { event, id, isExternal: true })
  }
</script>
